import React from "react";
import PageHeader from "../../components/Header/PageHeader";
import { PageWrapper } from "../../components/Page";
import { Button } from "../../components/Button";
import { ArrowForward, ShoppingCart, ArrowBack } from "@material-ui/icons";
import PageMenu from "../../components/Page/PageMenu";
import { Checkbox } from "../../components/Input";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCart,
  getCartId,
  getInstallation,
  getMeasurement,
} from "../../reducers/project/selectors";
import { ProjectActions } from "../../reducers/project/actionsNames";
import { useFetch } from "../../hooks/useFetch";
import { IProject } from "../../reducers/project";
import content from "../../content";
import { Stepper } from "../../components/Header";
import { DrawerMenu } from "../../components/Menu";
import { Mobile, useDesktop } from "../../components/Responsive";

function OrderServices({}: IOrderServices) {
  const installation = useSelector(getInstallation);
  const measurement = useSelector(getMeasurement);
  const cart: IProject[] = useSelector(getCart);
  const cartId = useSelector(getCartId);

  const [responseUpdate, requestUpdate] = useFetch<{
    id: string;
    projects: IProject[];
  }>("/cart/", {} as any, {
    method: "PUT",
  });

  const dispatch = useDispatch();

  const onChange = (name: string) => (e: any) => {
    let currentState = { installation, measurement };
    currentState[name] = e?.target?.checked;

    requestUpdate(
      {
        projects: cart,
        step: "Uslugi dodatkowe",
        services: currentState,
      },
      cartId
    );

    dispatch({ type: ProjectActions.SetServices, ...currentState });
  };

  const desktop = useDesktop();

  return (
    <>
      <PageHeader header={content.getValue("header_step_2")}>
        <Stepper />
      </PageHeader>
      <PageWrapper
        menu={
          <>
            <DrawerMenu
              Icon={
                <svg
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="21" cy="21" r="21" fill="#080808" />
                  <path
                    d="M30.6875 21C30.6875 26.3503 26.3503 30.6875 21 30.6875C15.6497 30.6875 11.3125 26.3503 11.3125 21C11.3125 15.6497 15.6497 11.3125 21 11.3125C26.3503 11.3125 30.6875 15.6497 30.6875 21ZM19.8795 26.1295L27.067 18.942C27.311 18.6979 27.311 18.3021 27.067 18.0581L26.1831 17.1742C25.939 16.9301 25.5433 16.9301 25.2992 17.1742L19.4375 23.0359L16.7008 20.2992C16.4568 20.0551 16.061 20.0551 15.8169 20.2992L14.933 21.183C14.689 21.4271 14.689 21.8229 14.933 22.0669L18.9955 26.1294C19.2396 26.3735 19.6354 26.3735 19.8795 26.1295Z"
                    fill="white"
                  />
                </svg>
              }
              title={content.getValue("drawer_services_title")}
              text={content.getValue("drawer_services_text")}
            />
            <div
              style={{
                marginTop: "auto",
                width: "100%",
                padding: "24px",
                boxSizing: "border-box",
              }}
            >
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "50%" }}>
                  <Link to={"/order"}>
                    <Button
                      variant={"text"}
                      startIcon={
                        <svg
                          width="17"
                          height="8"
                          viewBox="0 0 17 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.7308 0.659728 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM17 4.5H1V3.5H17V4.5Z"
                            fill="#838282"
                          />
                        </svg>
                      }
                      label={content.getValue("button_back")}
                    />
                  </Link>
                </div>
                <div style={{ width: "50%" }}>
                  <div
                    style={{
                      height: "20px",
                      pointerEvents:
                        !measurement && !installation ? "none" : "unset",
                    }}
                  >
                    <Link to={"/distributor"}>
                      <Button
                        disabled={!measurement && !installation}
                        Icon={
                          <svg
                            style={{
                              position: "absolute",
                              right: "20px",
                            }}
                            width="17"
                            height="8"
                            viewBox="0 0 17 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                              fill={
                                !measurement && !installation
                                  ? "rgba(0, 0, 0, 0.26)"
                                  : "#C41230"
                              }
                            />
                          </svg>
                        }
                        color={"secondary"}
                        variant={"outlined"}
                        label={content.getValue("button_next")}
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
      >
        <div style={{ width: desktop ? "70%" : "100%" }}>
          <p
            style={{
              marginBottom: "25px",
              color: "#666666",
              opacity: 0.6,
              fontSize: "14px",
            }}
          >
            {content.getValue("step_2_info")}
          </p>
          <div style={{ marginRight: "150px" }}>
            <Checkbox
              checked={measurement}
              value={measurement}
              onChange={onChange("measurement")}
              label={content.getValue("step_2_measurement")}
            />
            <Checkbox
              checked={installation}
              value={installation}
              onChange={onChange("installation")}
              label={content.getValue("step_2_installation")}
            />
          </div>
        </div>
        <Mobile>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginBottom: "24px",
            }}
          >
            <div style={{ width: "50%" }}>
              <Link to={"/order"}>
                <Button
                  variant={"text"}
                  startIcon={
                    <svg
                      width="17"
                      height="8"
                      viewBox="0 0 17 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.7308 0.659728 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM17 4.5H1V3.5H17V4.5Z"
                        fill="#838282"
                      />
                    </svg>
                  }
                  label={content.getValue("button_back")}
                />
              </Link>
            </div>
            <div style={{ width: "50%" }}>
              <div
                style={{
                  height: "20px",
                  pointerEvents:
                    !measurement && !installation ? "none" : "unset",
                }}
              >
                <Link to={"/distributor"}>
                  <Button
                    disabled={!measurement && !installation}
                    Icon={
                      <svg
                        style={{
                          position: "absolute",
                          right: "20px",
                        }}
                        width="17"
                        height="8"
                        viewBox="0 0 17 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                          fill={
                            !measurement && !installation
                              ? "rgba(0, 0, 0, 0.26)"
                              : "#C41230"
                          }
                        />
                      </svg>
                    }
                    color={"secondary"}
                    variant={"outlined"}
                    label={content.getValue("button_next")}
                  />
                </Link>
              </div>
            </div>
          </div>
        </Mobile>
      </PageWrapper>
    </>
  );
}

export interface IOrderServices {}

export default OrderServices;
